// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseSquareFilledSvg from "@fishx/icons-svg/es/asn/CloseSquareFilled";
import FishxIcon from '../components/FishxIcon';

var CloseSquareFilled = function CloseSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareFilledSvg
  }));
};

CloseSquareFilled.displayName = 'CloseSquareFilled';
export default React.forwardRef(CloseSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloseSquareFilled.js
// module id = 2242
// module chunks = 0